import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-xl-10 mb-5" }
const _hoisted_2 = { class: "d-none" }
const _hoisted_3 = { class: "card-header d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Copy", -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = {
  class: "accordion accordion-icon-toggle",
  id: "copy_accordion"
}
const _hoisted_7 = { class: "mt-5 d-flex justify-content-center" }
const _hoisted_8 = ["data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Propose ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionAccor = _resolveComponent("ActionAccor")!
  const _component_PersonalInfoAccor = _resolveComponent("PersonalInfoAccor")!
  const _component_ProposalReviewAccor = _resolveComponent("ProposalReviewAccor")!
  const _component_SettingAccor = _resolveComponent("SettingAccor")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.counter), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnProposal()))
        }, "Return proposal")
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionsList, (action, index) => {
              return (_openBlock(), _createBlock(_component_ActionAccor, {
                key: index,
                index: index,
                action: action,
                onAddAction: _ctx.addAction,
                onRemoveAction: _ctx.removeAction,
                onSetActions: _ctx.setActions
              }, null, 8, ["index", "action", "onAddAction", "onRemoveAction", "onSetActions"]))
            }), 128)),
            _createVNode(_component_PersonalInfoAccor, {
              selectedAccount: _ctx.account,
              actions: _ctx.actions.actions,
              onSetPersonalInfo: _ctx.setPersonalInfo
            }, null, 8, ["selectedAccount", "actions", "onSetPersonalInfo"]),
            _createVNode(_component_ProposalReviewAccor, { actions: _ctx.actionsData }, null, 8, ["actions"]),
            _createVNode(_component_SettingAccor, {
              onSetSetting: _ctx.setSetting,
              settingBlockInfo: _ctx.settingBlockInfo
            }, null, 8, ["onSetSetting", "settingBlockInfo"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.propose())),
              type: "button",
              class: "btn btn-primary btn-sm",
              "data-kt-indicator": _ctx.loadingPropose
            }, _hoisted_11, 8, _hoisted_8)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Loading, { height: '150px' })
        ]))
  ]))
}